/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {

    /**
     * @type {string}
     * @memberof CreateUserDto
     */
    firstName: string;

    /**
     * @type {string}
     * @memberof CreateUserDto
     */
    lastName: string;

    /**
     * @type {string}
     * @memberof CreateUserDto
     */
    fiscalCode: string;

    /**
     * @type {string}
     * @memberof CreateUserDto
     */
    email?: string | null;

    /**
     * @type {string}
     * @memberof CreateUserDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof CreateUserDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof CreateUserDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof CreateUserDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserDto
     */
    client?: JoinEntityDto;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof CreateUserDto
     */
    authorities?: Array<JoinEntityDto>;

    /**
     * @type {string}
     * @memberof CreateUserDto
     */
    note?: string | null;
}
